// extracted by mini-css-extract-plugin
module.exports = {"holder":"tabs_holder__2p3cD","containerOverride":"tabs_containerOverride__KN672","header":"tabs_header__2lCEy","disabled":"tabs_disabled__11Av3","active":"tabs_active__3IcAw"};